import React, { Component } from 'react';
import { connect } from 'react-redux';
import Utils from '../../utils/Utils.js';
import Leaderboard from './Leaderboard.js';
import {initNavbarState, setNavbarTitle} from 'actions/navbar.js';
import {fetchLeaderboardAndRecords} from 'actions/leaderboards.js';
import {getLeaderboard, getLeaderboardRecords, getLeaderboardRecordsEnd} from 'reducers/leaderboards.js';
import {getName, formatLeaderboardValue} from 'modules/leaderboards/tools.js';

class LeaderboardContainer extends Component {
    constructor(props) {
        super(props);
        this.limit = 15;
        this.busy = false; //use this in logic to avoid race conditions
        this.state = {busy:this.busy, error:null};
        this.onScroll = this.onScroll.bind(this);
        this.isMember = this.isMember.bind(this);
        this.isClickable = this.isClickable.bind(this);
        this.onClickRecord = this.onClickRecord.bind(this);
        this.setScrollContainer = this.setScrollContainer.bind(this);
        this.scrollContainer = null;
    }

    componentWillMount() {
        var leaderboard = this.props.leaderboard;
        var title = (leaderboard && (leaderboard.teamInfo ? leaderboard.teamInfo.title : leaderboard.title)) || '';
        this.props.dispatch(initNavbarState({enable:true, menuEnable:false, backButtonEnable:true, rewardsEnable:false, title:title}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        if(this.props.records.length==0) {
            this.nextPage();
        }
    }

    onScroll(event) {
        this.loadPageIfEndVisible();
    }

    setScrollContainer(el) {
        this.scrollContainer = el;
    }

    onClickRecord(record) {
        if(this.props.onClickRecord) {
            this.props.onClickRecord(record);
        }
    }

    loadPageIfEndVisible() {
        if(this.scrollContainer) {
            var scrollTop =    this.scrollContainer.scrollTop;
            var scrollHeight = this.scrollContainer.scrollHeight;
            var clientHeight = this.scrollContainer.clientHeight;
            var lastPageInView = (scrollTop >= scrollHeight - 1.5*clientHeight);
            if(lastPageInView && this.busy==false && this.props.end==false) {
                this.nextPage();
            }
        }
    }

    componentWillReceiveProps(newProps) {
        var oldTitle = (this.props.leaderboard && this.props.leaderboard.title) || '';
        var newTitle = (newProps.leaderboard && newProps.leaderboard.title) || '';
        if(oldTitle!==newTitle) {
            this.props.dispatch(setNavbarTitle(newTitle));
        }
    }

    nextPage() {
        console.log('nextPage');
        if(!this.busy) {
            this.busy = true;
            this.setState({busy:this.busy});
            var start = this.props.records.length;
            var leaderboardId = this.props.leaderboard ? this.props.leaderboard.id : this.props.match.params.id;
            this.props.loadData(leaderboardId, start, this.limit)
                .then((records)=> {
                    if(records.length) {
                        Utils.delay(100).then(()=>{this.loadPageIfEndVisible()});
                    }
                })
                .catch((error)=> {
                    console.error('ERROR:');
                    console.error(error);
                    this.setState({error:error});
                })
                .then(()=>{
                    this.busy = false;
                    this.setState({busy:this.busy});
                });
        }
    }

    getAvatars(scopeObj) {
        var objs = [scopeObj];
        if(Array.isArray(scopeObj)) {
            objs = scopeObj;
        }
        return objs.map(o=>(o.avatar!=null ? o.avatar.url : null));
    }

    isMember(record) {
        if(this.props.userProfileId==null) {
            return false;
        }
        if(record.userProfiles) {
            var userProfiles = record.userProfiles;
            for(var i = 0; i < userProfiles.length; i++) {
                if(userProfiles[i].id===this.props.userProfileId) {
                    return true;
                }
            }
            return false;
        }
        if(record.teamId) {
            return record.teamId===this.props.teamId;
        }
        return (this.props.userProfileId===record.userProfileId);
    }

    isClickable(record) {
        return Boolean(record && record.team && record.team.leaderboard);
    }

    render() {
        var column = this.props.column;
        var targetPoints = 0;
        var leaderboard = this.props.leaderboard;
        if(leaderboard) {
            if(this.props.records && this.props.records.length && this.props.records[0][column] > targetPoints) {
                targetPoints = this.props.records[0][column]
            }
        }
        return <Leaderboard getName={getName}
                            formatLeaderboardValue={formatLeaderboardValue}
                            getAvatars={this.getAvatars}
                            leaderboard={this.props.leaderboard}
                            records={this.props.records}
                            targetPoints={targetPoints}
                            onClickRecord={this.onClickRecord}
                            column={column}
                            onScroll={this.onScroll}
                            isMember={this.isMember}
                            isClickable={this.isClickable}
                            setScrollContainer={this.setScrollContainer}
                            busy={this.state.busy}
                            error={this.state.error} />;
    }

}

export {LeaderboardContainer as LeaderboardContainerUnconnected};

const mapStateToProps = (state, ownProps) => {
    var leaderboardId = ownProps.match.params.id;
    var userProfile = state.user.userProfile;
    var leaderboard = getLeaderboard(state.leaderboards, leaderboardId);
    var column = leaderboard ? (leaderboard.column || 'points') : null;
    return {userProfileId:(userProfile ? userProfile.id : null),
            teamId: (userProfile? userProfile.teamId : null),
            leaderboard:leaderboard, 
            column:column, 
            records:getLeaderboardRecords(state.leaderboards, leaderboardId),
            end:getLeaderboardRecordsEnd(state.leaderboards, leaderboardId)};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: (id, start, limit) => dispatch(fetchLeaderboardAndRecords(id, start, limit)),
        dispatch: dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaderboardContainer);



// WEBPACK FOOTER //
// ./src/modules/leaderboards/LeaderboardContainer.js